// TODO: La [unica hoja con material-ui porque Carlos lo va cambiar, eso creo xD
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ExpandMore, Done } from 'styled-icons/material';
import { CloseOutline } from 'styled-icons/evaicons-outline';
import { EditAlt, CheckCircle } from 'styled-icons/boxicons-regular';
import Draggable from 'react-draggable';
import BarLoader from 'react-spinners/BarLoader';
import Accordion from '@material-ui/core/Accordion';
import { Dialog } from '@progress/kendo-react-dialogs';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import CustomUploadButton from 'react-firebase-file-uploader/lib/CustomUploadButton';
import { ChromePicker } from 'react-color';
import { firebase } from '../../../model/firebase/firebase';
import { newUpdatePlatform } from '../../../redux/actions/_initializer_actions';
import { ShowNotification } from '../../Notifications';
import { palette } from '../../../system/styles/styles';

const imageFirstSection =
  'https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Fcharles-deluvio-DgoyKNgPiFQ-unsplash.jpg?alt=media&token=43b4fe30-efec-471c-821a-99e572d67df5';
const imageSecondSection =
  'https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Fpexels-sora-shimazaki-5668862.jpg?alt=media&token=798e7fd5-0349-4cac-85d4-5bed3e9549f8';
const loginDefaultImage =
  'https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2FlogoLogin.jpg?alt=media&token=6abaa23a-18f6-4db6-808e-32868dfb0199';
const loginAdminDefaultImage =
  'https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2FAdminLogin.jpg?alt=media&token=1c081888-7de6-4b3a-817d-9ea5f8650b25';

const PageEditor = ({ handleEditor }) => {
  const platform = useSelector((state) => state.platform);
  const dispatch = useDispatch();

  const [state, setState] = useState({
    currentEditorOption: 'content',
    isUploading: false,
  });
  const [platformData, setPlatformData] = useState({
    customImage: platform.customImage,
    customSecondImageLink: platform.customSecondImageLink,
    customThirdImage: platform.customThirdImage,
    mainTitle: platform.mainTitle,
    mainSubText: platform.mainSubText,
    companyTitle: platform.companyTitle,
    contentTitle: platform.contentTitle,
    companySubText: platform.companySubText,
    companyText: platform.companyText,
    studentTitle: platform.studentTitle,
    studentSubText: platform.studentSubText,
    studentText: platform.studentText,
    facebookLink: platform.facebookLink ? platform.facebookLink : '',
    instagramLink: platform.instagramLink ? platform.instagramLink : '',
    twitterLink: platform.twitterLink ? platform.twitterLink : '',
    youtubeLink: platform.youtubeLink ? platform.youtubeLink : '',
    linkedinLink: platform.linkedinLink ? platform.linkedinLink : '',
    primaryColor: platform?.primaryColor || '',
    platformLogo: platform.platformLogo,
    interfaceSelected: platform.interfaceSelected,
    customLoginImage: platform.customLoginImage,
    customLoginAdminImage: platform.customLoginAdminImage,
    userTypeText: platform.userTypeText,
    companyTypeText: platform.companyTypeText,
    logoLink1: platform.logoLink1,
    logoLink2: platform.logoLink2,
    logoLink3: platform.logoLink3,
    logoLink4: platform.logoLink4,
    logoLink5: platform.logoLink5,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPlatformData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handlePage = (option) => {
    setState((prevState) => ({
      ...prevState,
      currentEditorOption: option,
    }));
  };

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isUploading: false,
    }));
  };

  const handleUploadStart = () => {
    setState((prevState) => ({ ...prevState, isUploading: true, progress: 0, imageChangesOn: true }));
  };

  const handleProgress = (progress) => setState((prevState) => ({ ...prevState, progress }));

  const handleUploadError = () => {
    setState((prevState) => ({ ...prevState, isUploading: false }));
  };

  const handleUploadSuccess = async (file) => {
    const url = await firebase
      .storage()
      .ref(`platforms/${platform.platformName}/CustomImages/`)
      .child(file)
      .getDownloadURL();
    const filedName = file.substr(0, file.indexOf('.'));
    dispatch(newUpdatePlatform({ [filedName]: url }));
    setPlatformData((prevState) => ({
      ...prevState,
      [filedName]: url,
    }));
    ShowNotification('success', 'Se actualizó de manera correcta', 'Acción completada');
    setState((prevState) => ({ ...prevState, progress: 100, isUploading: false }));
  };

  const handleChangeComplete = (color) => {
    setPlatformData((prevState) => ({ ...prevState, primaryColor: color.hex }));
  };

  const saveChanges = async () => {
    dispatch(newUpdatePlatform(platformData));
    ShowNotification('success', 'Se actualizó de manera correcta', 'Acción completada');
  };

  const handleInterface = (Interface) => {
    setPlatformData((prevState) => ({
      ...prevState,
      interfaceSelected: Interface,
    }));
  };

  return (
    <Draggable defaultPosition={{ x: 100, y: 40 }}>
      <div className="editorContainer">
        <div className="editorNavTitle">
          <div>
            <p className="editorTitle">Edición de pagína</p>
            <p className="editorVersion">version 1.0</p>
          </div>
          <CloseOutline size={20} onClick={handleEditor} />
        </div>
        <div className="editorNavTabs">
          <p
            className={state.currentEditorOption === 'content' ? 'editorTabActive' : 'editorTab'}
            onClick={() => handlePage('content')}>
            Contenido
          </p>
          <p
            className={state.currentEditorOption === 'color' ? 'editorTabActive' : 'editorTab'}
            onClick={() => handlePage('color')}>
            Color
          </p>
          <p
            className={state.currentEditorOption === 'logo' ? 'editorTabActive' : 'editorTab'}
            onClick={() => handlePage('logo')}>
            Imágenes
          </p>
        </div>
        <div className="editorChildContainer">
          {state.currentEditorOption === 'content' ? (
            <div>
              <Accordion elevation={0}>
                <AccordionSummary
                  expandIcon={<ExpandMore size={20} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header">
                  <p className="accordionTitle">Portada</p>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordionArea">
                    <div className="accordionCard">
                      <label className="inputLabel">Versión de portada</label>
                      <div className="interfaceOptions">
                        <div
                          className={platformData.interfaceSelected === 1 ? 'optionSelected1' : 'optionAvailable1'}
                          onClick={() => handleInterface(1)}>
                          <div className="optionSelectedIcon">
                            <CheckCircle color="#21fffe" size={20} />
                            <label className="accordionLabel">Seleccionada</label>
                          </div>
                        </div>
                        <div
                          className={platformData.interfaceSelected === 2 ? 'optionSelected2' : 'optionAvailable2'}
                          onClick={() => handleInterface(2)}>
                          <div className="optionSelectedIcon">
                            <CheckCircle color="#21fffe" size={20} />
                            <label className="accordionLabel">Seleccionada</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="accordionCard">
                      <label className="inputLabel">Imagen de portada</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="customImageURL"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                    url(${
                                                      platform.customImageURL !== ''
                                                        ? platform.customImageURL
                                                        : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fhero-image-bg.png?alt=media&token=3e9aff77-7b55-4bc8-85c8-48b0bebfceab'
                                                    }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="mainTitle">
                          Texto principal
                        </label>
                        <input
                          className="signupInput100"
                          value={platformData.mainTitle}
                          onChange={handleInputChange}
                          id="mainTitle"
                          name="mainTitle"
                        />
                      </div>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="mainSubText">
                          Sub texto
                        </label>
                        <textarea
                          className="signupSelect100"
                          value={platformData.mainSubText}
                          rows={3}
                          onChange={handleInputChange}
                          id="mainSubText"
                          name="mainSubText"
                        />
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion elevation={0}>
                <AccordionSummary
                  expandIcon={<ExpandMore size={20} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header">
                  <p className="accordionTitle">{platform.userTypeText}</p>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordionCard">
                    <div className="accordionCard">
                      <label className="accordionLabel">Background</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="customThirdImage"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                    url(${
                                                      platform.customThirdImage !== ''
                                                        ? platform.customThirdImage
                                                        : imageFirstSection
                                                    }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="studentTitle">
                          Titulo
                        </label>
                        <input
                          className="signupInput100"
                          value={platformData.studentTitle}
                          onChange={handleInputChange}
                          id="studentTitle"
                          name="studentTitle"
                        />
                      </div>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="studentText">
                          Texto
                        </label>
                        <textarea
                          className="signupSelect100"
                          value={platformData.studentText}
                          rows={3}
                          id="studentText"
                          onChange={handleInputChange}
                          name="studentText"
                        />
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion elevation={0}>
                <AccordionSummary
                  expandIcon={<ExpandMore size={20} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header">
                  <p className="accordionTitle">Empresas</p>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordionCard">
                    <div className="accordionCard">
                      <label className="accordionLabel">Imagen</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="customSecondImageLink"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                        url(${
                                                          platform.customSecondImageLink !== ''
                                                            ? platform.customSecondImageLink
                                                            : imageSecondSection
                                                        }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="companyTitle">
                          Titulo
                        </label>
                        <input
                          className="signupInput100"
                          value={platformData.companyTitle}
                          onChange={handleInputChange}
                          id="companyTitle"
                          name="companyTitle"
                        />
                      </div>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="companyText">
                          Texto
                        </label>
                        <textarea
                          className="signupSelect100"
                          value={platformData.companyText}
                          rows={3}
                          id="companyText"
                          onChange={handleInputChange}
                          name="companyText"
                        />
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion elevation={0}>
                <AccordionSummary
                  expandIcon={<ExpandMore size={20} />}
                  aria-controls="panel2a-content"
                  id="panel2a-header">
                  <p className="accordionTitle">Footer</p>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordionCard">
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="facebookLink">
                          Facebook
                        </label>
                        <input
                          className="signupInput100"
                          value={platformData.facebookLink}
                          id="facebookLink"
                          onChange={handleInputChange}
                          name="facebookLink"
                        />
                      </div>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="twitterLink">
                          Twitter
                        </label>
                        <input
                          className="signupInput100"
                          value={platformData.twitterLink}
                          id="twitterLink"
                          name="twitterLink"
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="instagramLink">
                          Instagram
                        </label>
                        <input
                          className="signupInput100"
                          value={platformData.instagramLink}
                          id="instagramLink"
                          name="instagramLink"
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="youtubeLink">
                          Youtube
                        </label>
                        <input
                          className="signupInput100"
                          id="youtubeLink"
                          value={platformData.youtubeLink}
                          name="youtubeLink"
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="accordionCard">
                      <div className="inputBox100">
                        <label className="inputLabel" htmlFor="linkedinLink">
                          Linkedin
                        </label>
                        <input
                          className="signupInput100"
                          id="linkedinLink"
                          value={platformData.linkedinLink}
                          name="linkedinLink"
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          ) : null}
          {state.currentEditorOption === 'color' ? (
            <div>
              <div className="accordionArea">
                <div className="accordionCard">
                  <div className="inputBox100">
                    <label className="inputLabel" htmlFor="primaryColor">
                      Color principal
                    </label>
                    <input
                      className="signupInput100"
                      value={platformData?.primaryColor}
                      onChange={handleInputChange}
                      id="primaryColor"
                      name="primaryColor"
                    />
                    <ChromePicker color={platformData?.primaryColor} onChangeComplete={handleChangeComplete} />
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {state.currentEditorOption === 'logo' ? (
            <div>
              <Accordion elevation={0}>
                <AccordionSummary
                  expandIcon={<ExpandMore size={20} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header">
                  <p className="accordionTitle">Logo principal</p>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordionArea">
                    <div className="accordionCard">
                      <label className="accordionLabel">Logo principal</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="platformLogo"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                        url(${platform.platformLogo}) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion elevation={0}>
                <AccordionSummary
                  expandIcon={<ExpandMore size={20} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header">
                  <p className="accordionTitle">Logos empresas</p>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordionArea">
                    <div className="accordionCard">
                      <label className="inputLabel">Logo #1</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="platformCustomLogo1"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                 url(${
                                                   platform.platformCustomLogo1
                                                     ? platform.platformCustomLogo1
                                                     : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Faxa.svg?alt=media&token=5a796ff8-8224-49b5-a5b3-a8f2574c18f7'
                                                 }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                      <input
                        type="text"
                        value={platformData.logoLink1}
                        onChange={handleInputChange}
                        name="logoLink1"
                        placeholder="Ingresar link (Opcional)"
                        className="inputLink"
                      />
                    </div>
                    <div className="accordionCard">
                      <label className="inputLabel">Logo #2</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="platformCustomLogo2"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                        url(${
                                                          platform.platformCustomLogo2
                                                            ? platform.platformCustomLogo2
                                                            : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fmoons.svg?alt=media&token=209ecb8e-0e40-4b65-a006-a2d5aa73ca48'
                                                        }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                      <input
                        type="text"
                        value={platformData.logoLink2}
                        onChange={handleInputChange}
                        name="logoLink2"
                        placeholder="Ingresar link (Opcional)"
                        className="inputLink"
                      />
                    </div>
                    <div className="accordionCard">
                      <label className="inputLabel">Logo #3</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="platformCustomLogo3"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                        url(${
                                                          platform.platformCustomLogo3
                                                            ? platform.platformCustomLogo3
                                                            : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fconekta.png?alt=media&token=41812e5c-bc86-4279-b939-fc6cc19e19c5'
                                                        }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                      <input
                        type="text"
                        value={platformData.logoLink3}
                        onChange={handleInputChange}
                        name="logoLink3"
                        placeholder="Ingresar link (Opcional)"
                        className="inputLink"
                      />
                    </div>
                    <div className="accordionCard">
                      <label className="inputLabel">Logo #4</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="platformCustomLogo4"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                        url(${
                                                          platform.platformCustomLogo4
                                                            ? platform.platformCustomLogo4
                                                            : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fmercado.png?alt=media&token=90069f53-2c4d-42fd-a7bb-d3dbd8ace132'
                                                        }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                      <input
                        type="text"
                        value={platformData.logoLink4}
                        onChange={handleInputChange}
                        name="logoLink4"
                        placeholder="Ingresar link (Opcional)"
                        className="inputLink"
                      />
                    </div>
                    <div className="accordionCard">
                      <label className="inputLabel">Logo #5</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="platformCustomLogo5"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                        url(${
                                                          platform.platformCustomLogo5
                                                            ? platform.platformCustomLogo5
                                                            : 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fjusto.png?alt=media&token=7ad86670-48ed-4123-ab20-cff47fe0cb5e'
                                                        }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                      <input
                        type="text"
                        value={platformData.logoLink5}
                        onChange={handleInputChange}
                        name="logoLink5"
                        placeholder="Ingresar link (Opcional)"
                        className="inputLink"
                      />
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion elevation={0}>
                <AccordionSummary
                  expandIcon={<ExpandMore size={20} />}
                  aria-controls="panel1a-content"
                  id="panel1a-header">
                  <p className="accordionTitle">Imágenes iniciar sesión</p>
                </AccordionSummary>
                <AccordionDetails>
                  <div className="accordionArea">
                    <div className="accordionCard">
                      <label className="inputLabel">{`${platform.userTypeText} / ${platform.companyTypeText}`}</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="customLoginImage"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                        url(${
                                                          platform.customLoginImage === ''
                                                            ? loginDefaultImage
                                                            : platform.customLoginImage
                                                        }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                    </div>
                    <div className="accordionCard">
                      <label className="inputLabel">Administrador</label>
                      <CustomUploadButton
                        accept="images/"
                        filename="customLoginAdminImage"
                        storageRef={firebase.storage().ref(`platforms/${platform.platformName}/`).child('CustomImages')}
                        onUploadStart={handleUploadStart}
                        onUploadError={handleUploadError}
                        onUploadSuccess={handleUploadSuccess}
                        onProgress={handleProgress}
                        className="width100">
                        <div
                          className="editIamge"
                          style={{
                            background: `linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),
                                                 url(${
                                                   platform.customLoginAdminImage === ''
                                                     ? loginAdminDefaultImage
                                                     : platform.customLoginAdminImage
                                                 }) center / cover`,
                          }}>
                          <EditAlt size={20} />
                          <label className="accordionLabel">Editar</label>
                        </div>
                      </CustomUploadButton>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
          ) : null}
        </div>
        <div className="editorButtonsOptions">
          <p className="editorButtonCancel" onClick={handleEditor}>
            <CloseOutline size={20} />
          </p>
          <p className="editorButtonSave" onClick={saveChanges}>
            <Done size={20} />
          </p>
        </div>
        {state.isUploading ? (
          <Dialog className="backdrop">
            <BarLoader sizeUnit="px" size={250} color={palette.blue} />
          </Dialog>
        ) : null}
      </div>
    </Draggable>
  );
};
export default PageEditor;
